var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"three-bounce",class:{'-tiny': _vm.tiny}},[_c('div',{staticClass:"child bounce1"}),_c('div',{staticClass:"child bounce2"}),_c('div',{staticClass:"child bounce3"})])])}
var staticRenderFns = []

export { render, staticRenderFns }